import script from "./LevelsSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./LevelsSelect.vue?vue&type=script&lang=ts&setup=true"

import "./LevelsSelect.vue?vue&type=style&index=0&id=6cc994eb&lang=css&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc994eb"]])

export default __exports__